import { useEffect } from "react";
import { enableFormTracking } from "@snowplow/browser-plugin-form-tracking";
import { enableActivityTracking } from "@snowplow/browser-tracker";
import { SubscriptionContextGenerator } from "./SubscriptionContextGenerator/SubscriptionContextGenerator";
import { TutorContextGenerator } from "./TutorContextGenerator/TutorContextGenerator";
import { featureFlags } from "../../utils/featureFlags";
export var useSnowplowFormTracking = function (props) {
    var isEnabled = props.isEnabled, userUpdated = props.userUpdated;
    useEffect(function () {
        if (!isEnabled)
            return;
        if (userUpdated) {
            var submitFormContexts = [
                new SubscriptionContextGenerator().formSubmitEnricher,
                new TutorContextGenerator().formSubmitEnricher,
            ];
            enableActivityTracking({ heartbeatDelay: 10, minimumVisitLength: 30 });
            enableFormTracking({
                options: {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    events: ["submit_form", "focus_form"],
                },
                context: featureFlags.SUBMIT_SNOWPLOW_FORM_CONTEXTS
                    ? submitFormContexts
                    : undefined,
            });
        }
    }, [isEnabled, userUpdated]);
};
